import styled from 'styled-components';

export const FreeProductCard = styled.div`
  background: linear-gradient(90deg, #d6f2f5, #d2edde, #fae7e1, #fdf4d2);
  display: flex;
  justify-content: space-between;
  padding: 12px 0px 12px 10px;
  margin: 0 10px;
  box-shadow: 0px 1px 3px 0px #00000026;

  .product_image {
    width: 68px;
    height: 68px;
    border-radius: 4px;
  }
`;

export const ItemDetail = styled.div`
  padding-left: 18px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .product_name {
    font-size: clamp(12px, 2vw, 14px);
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 87%);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  button {
    font-family: 'Montserrat';
    background: #fff;
    border: none;
    outline: none;
    padding: 6px 11px;
    border-radius: 10vmax;
    font-size: 11px;
    font-weight: 500;
    color: #ef4e5e;
    position: relative;
    overflow: hidden;
    @media (min-width: 720px) {
      cursor: pointer;
    }

    span.ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: ripple 600ms linear;
      background-color: #00000026;
    }

    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  }
`;

export const ChangeProduct = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
`;

export const VermArrow = styled.img`
  width: 8px;
  height: 8px;
  transform: rotate(180deg);
`;
